module.exports = __webpack_public_path__ + "static/media/api-banner-big.5a666445.png";